export default __webpack_public_path__ + "static/media/ic_kyberswap.6fe90e35.svg";